import { AllSelection, TextSelection } from 'prosemirror-state';

import { isListNode } from './utils';

import { clamp } from 'lodash';

const BLOCKQUOTE = 'blockquote';
const HEADING = 'heading';
const LIST_ITEM = 'list_item';
const PARAGRAPH = 'paragraph';
const MIN_INDENT_LEVEL = 0;
const MAX_INDENT_LEVEL = 3;

export default function updateIndentLevel(tr, schema, delta) {
  const { doc, selection } = tr;
  if (!doc || !selection) {
    return tr;
  }

  if (
    !(selection instanceof TextSelection || selection instanceof AllSelection)
  ) {
    return tr;
  }

  const { nodes } = schema;
  const { from, to } = selection;
  const listNodePoses: any[] = [];

  const blockquote = nodes[BLOCKQUOTE];
  const heading = nodes[HEADING];
  const paragraph = nodes[PARAGRAPH];

  let out = tr;

  doc.nodesBetween(from, to, (node, pos) => {
    const nodeType = node.type;
    if (
      nodeType === paragraph ||
      nodeType === heading ||
      nodeType === blockquote
    ) {
      out = setNodeIndentMarkup(tr, schema, pos, delta);
      return false;
    }

    if (isListNode(node)) {
      // List is tricky, we'll handle it later.
      listNodePoses.push(pos);
      return false;
    }

    return true;
  });

  if (!listNodePoses.length) {
    return out;
  }

  return out;
}

function setNodeIndentMarkup(tr, schema, pos, delta) {
  if (!tr.doc) {
    return tr;
  }
  const node = tr.doc.nodeAt(pos);
  if (!node) {
    return tr;
  }
  const indent = clamp(
    MIN_INDENT_LEVEL,
    (node.attrs.indent || 0) + delta,
    MAX_INDENT_LEVEL,
  );
  if (indent === node.attrs.indent) {
    return tr;
  }
  const nodeAttrs = {
    ...node.attrs,
    indent,
  };
  return tr.setNodeMarkup(pos, node.type, nodeAttrs, node.marks);
}
